<template>
    <div class="checkout-step">
        <div class="header is-marginless">
            <h1 class="title">Pedido</h1>
        </div>

        <ul class="order">
            <li v-for="item in items" :product="item" :key="item.id">
                {{ item.quantity }} x {{ item.product.name | toLowercase }}
                <span style="float: right;">$ {{ item.product.price }}</span>
            </li>
        </ul>

        <div class="level is-mobile">
            <div class="level-left">
                <span class="total">Subtotal</span>
            </div>
            <div class="level-right">
                <span class="total">{{ cart.subtotal | toCurrency }}</span>
            </div>
        </div>

        <div class="level is-mobile">
            <div class="level-left">
                <span class="total">Envio</span>
            </div>
            <div class="level-right">
                <span class="total">{{ cart.shippingCost | toCurrency }}</span>
            </div>
        </div>

        <div class="level is-mobile" v-for="discount in cart.discounts" :discount="discount" :key="discount.id">
            <div class="level-left">
                <span class="total">{{ discount.name }}</span>
            </div>
            <div class="level-right">
                <span class="total">{{ -discount.amount | toCurrency }}</span>
            </div>
        </div>

        <div class="level is-mobile">
            <div class="level-left">
                <span class="total">Total</span>
            </div>
            <div class="level-right">
                <span class="total">{{ cart.total | toCurrency }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cart: Object
        },

        computed: {
            items() {
                return this.$store.getters['cart/get']().items.filter(ci => ci.product.type === 'product');
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "./../../assets/css/checkout.scss";

    .order {
        margin-bottom: 20px;
    }

    .total {
        font-weight: bold;
    }
</style>